import { env } from '@/config/env';

export function toAbsoluteUrl(u?: string): string | undefined {
  if (!u) return undefined;
  if (/^https?:\/\//i.test(u)) return u;
  const base = env.apiUrl.replace(/\/$/, '');
  const path = u.replace(/^\//, '');
  return `${base}/${path}`;
}
